import { IUnitDefaultHandlersNode, UnitDefaultHandlersNode } from "./unitDefaultHandlersNode";

export interface IUnitNodeDefaultHandlers {
    unitNode: IUnitDefaultHandlersNode;
}

export class UnitNodeDefaultHandlers implements IUnitNodeDefaultHandlers {
    unitNode: UnitDefaultHandlersNode;

    constructor();
    constructor(obj: IUnitNodeDefaultHandlers);
    constructor(obj?: any) {
        this.unitNode = new UnitDefaultHandlersNode(obj && obj.unitNode ? obj.unitNode : null);
    }
}